<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('archive.expedient_management')"
      :columns="columns"
      :column_search="false"
      resource_url="/archive/expedient/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("archive.new_expedient") }}</span>
        </button>
      </template>
    </generic-table>

    <expedient-modal ref="expedient_modal" @success="refresh" />
    <expedient-detail-modal ref="expedient_detail_modal" @edit="edit" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_date,
} from "@/utils";
import ExpedientModal from "./expedient_modal/Index.vue";
import ExpedientDetailModal from "./expedient_detail_modal/Index.vue";

export default {
  name: "ExpedientsDatatable",
  components: {
    GenericTable,
    ExpedientModal,
    ExpedientDetailModal,
  },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("expedient"),
          name: "expedient_number",
          data: (row) => {
            return `<div class="title is-6">${row.expedient_number || ""}</div>
                    <div class="subtitle is-6 has-text-grey">${
                      row.name || ""
                    }</div>`;
          },
        },
        {
          title: v.$t("archive.customer"),
          searchable: false,
          name: "$customer.name$",
          data: (row) => {
            return `<div class="title is-6">${row.customer?.name || ""}</div>
                    <div class="subtitle is-6 has-text-grey">${
                      row.expedient_type?.name || ""
                    }</div>`;
          },
        },
        {
          title: v.$t("archive.status"),
          searchable: false,
          data: (row) => {
            // Status
            const statusColors = {
              active: "is-success",
              pending: "is-warning",
              closed: "is-dark",
              archived: "is-light",
            };
            const statusColorClass = statusColors[row.status] || "is-light";
            let status_tag = `<div class="control">
    <div class="tags has-addons">
      <span class="tag is-dark">${v.$t("archive.status")}</span>
      <span class="tag ${statusColorClass}">${row.status}</span>
    </div>
  </div>`;
            // let status_tag =
            //   '<span class="tag ' +
            //   statusColorClass +
            //   '">' +
            //   v.$t("archive.status_" + row.status) +
            //   "</span>";

            // Priority
            const priorityColors = {
              low: "is-info",
              medium: "is-primary",
              high: "is-warning",
              urgent: "is-danger",
            };
            const priorityColorClass =
              priorityColors[row.priority] || "is-light";
            let priority_tag = `<div class="control">
    <div class="tags has-addons">
      <span class="tag is-dark">${v.$t("archive.priority")}</span>
      <span class="tag ${priorityColorClass}">${row.priority}</span>
    </div>
  </div>`;
            // let priority_tag =
            //   '<span class="tag ' +
            //   priorityColorClass +
            //   '">' +
            //   v.$t("archive.priority_" + row.priority) +
            //   "</span>";

            // File count
            let file_count_tag = `<div class="control">
              <div class="tags has-addons">
                <span class="tag is-dark">${v.$t("archive.files")}</span>
                <span class="tag is-info">${row.file_count || 0}</span>
              </div>
            </div>`;
            // const file_count_tag =
            //   '<span class="tag is-light">' + (row.file_count || 0) + "</span>";

            return `<div class="field is-grouped">${status_tag} ${priority_tag} ${file_count_tag}</div>`;
          },
        },
        {
          title: v.$t("create_date"),
          searchable: false,
          data: (row) => {
            return format_date(row.create_date);
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              // {
              //   args: { expedient_id: row.expedient_id },
              //   tooltip: v.$t("details"),
              //   icon: "fa fa-eye",
              //   icon_class: "is-small",
              //   click: function (e) {
              //     v.$refs.expedient_detail_modal.show(row.uuid);
              //   },
              // },
              {
                args: { expedient_id: row.expedient_id },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  v.edit(row.uuid);
                },
              },
              {
                args: { expedient_id: row.expedient_id },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  if (row.file_count > 0) {
                    error_message(
                      v.$t("archive.cannot_delete_expedient_with_files")
                    );
                    return;
                  }
                  confirm_deletion_dialog(
                    v.$t("archive.confirm_delete_expedient"),
                    v,
                    () => {
                      del("/archive/expedient", {
                        expedient_id: row.uuid,
                      })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_date,
    create() {
      let v = this;
      v.$refs.expedient_modal.show_modal();
    },
    edit(uuid) {
      let v = this;
      v.$refs.expedient_modal.show_modal(uuid);
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
